var render, staticRenderFns
import script from "./form_detail.vue?vue&type=script&lang=js"
export * from "./form_detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins_home/workspace/tax-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b515286')) {
      api.createRecord('6b515286', component.options)
    } else {
      api.reload('6b515286', component.options)
    }
    
  }
}
component.options.__file = "found/views/kms_new/views/order_display/return_order/form/components/form_detail.vue"
export default component.exports